// src/app/core/interceptors/auth401.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpInterceptor, HttpRequest, HttpHandler, HttpEvent
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Auth401Service } from '../../services/auth-401.service';

@Injectable()
export class Auth401Interceptor implements HttpInterceptor {
  constructor(private auth401: Auth401Service) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError(err => {
        if (err.status === 401) {
          // não disparar logout por 401 do próprio endpoint de logout
          const url = (req.url || '').toLowerCase();
          const isLogout = url.endsWith('/logout') || url.includes('/auth/logout');
          const isAppProduct = url.includes('/app_product');
          const list_articles = url.includes('/list_articles');
          const list_collections = url.includes('/list_collections');
          if (!isLogout && !isAppProduct && !list_articles && !list_collections) {
            this.auth401.forceLogout(true); // <- fromInterceptor = true
          }
        }
        return throwError(() => err);
      })
    );
  }
}
